import { render, staticRenderFns } from "./pageAction.vue?vue&type=template&id=9bf140de&scoped=true&lang=html&"
import script from "./pageAction.vue?vue&type=script&lang=js&"
export * from "./pageAction.vue?vue&type=script&lang=js&"
import style0 from "./pageAction.vue?vue&type=style&index=0&id=9bf140de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf140de",
  null
  
)

export default component.exports